<div class="content">
  <div class="top-bar">
    <div class="logoContainer">
      <img src="../../assets/new-co-logo-lg.png" alt="CareOregon Logo" class="logo" />
    </div>
    <span>Dental Bidirectional</span>
  </div>

  <div class="login-container">
    <h1>Welcome to Dental Bidirectional</h1>

    <p *ngIf="autoLoginInProgress">Attempting automatic login via HealthTrio...</p>

    <div *ngIf="!autoLoginInProgress">
      <button mat-raised-button color="primary" (click)="loginWithHealthTrio()">
        Login with HealthTrio
      </button>

      <button mat-raised-button color="accent" (click)="loginWithCareOregon()">
        Login with CareOregon
      </button>
    </div>
  </div>
  
</div>
